import classNames from "classnames";
import { CloseButton, EditIcon, OverviewIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import posthog from "posthog-js";

interface ConstructionHeaderProps {
    isEditing: boolean;
    handleCancel: () => void;
    handleEdit: () => void;
}

function ConstructionHeader({ isEditing, handleCancel, handleEdit }: ConstructionHeaderProps) {
    return (
        <div className={classNames("construction-sidebar__header", isEditing && "editing")}>
            <OverviewIcon />
            <Header size="medium">{isEditing ? "Edit construction" : "Overview"}</Header>
            {isEditing ? (
                <CloseButton id="edit-construction-close-button" onClick={handleCancel} />
            ) : (
                <button
                    type="button"
                    id="edit-construction-button"
                    onClick={() => {
                        handleEdit();
                        posthog.capture("Edit-construction started");
                    }}
                >
                    <EditIcon />
                </button>
            )}
        </div>
    );
}

export default ConstructionHeader;
